<div class="d-flex align-items-center mb-6">
  <base-avatar
    [image]="avatarSrc"
    [size]="avatarSize.intermediate"
    [title]="comment.authorFullName"
  ></base-avatar>
  <div class="ps-2">
    <div class="fw-bold">
      {{ comment.authorFullName }}
    </div>
    <div>{{ comment.createdAt | baseFormatDate }} | {{ comment.createdAt | baseFormatTime }} h</div>
  </div>
</div>
<div
  *ngIf="comment.type"
  class="fw-bold mb-2 {{ 'text-' + statusData.color }}"
>
  {{ statusData.name | translate }}
</div>
<div
  *ngIf="comment.comment"
  [innerText]="comment.comment"
></div>
